import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

// Helper
import { Helper } from '../helpers/helper';
@Injectable()
export class ReportesService {

  constructor(private http: HttpClient, private helper: Helper) { }


  reporteRentabilidad(fechas?, rutas?, limit?, offset?, region?, subregion?) {
    let params = new HttpParams();
    if (region) {
      params = params.append('region', region);
    }
    if (subregion) {
      params = params.append('subregion', subregion);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (fechas) {

      params = params.append('fecha_inicia', fechas.fecha_inicia);
      params = params.append('fecha_termina', fechas.fecha_termina);
    }
    if (limit) {

      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/reporte-rentabilidad-de-rutas`,
    {headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  obtenerConfiguraciones() {
    return this.http.get(`${this.helper.urlServer}/api/v1/configuracion-prestamo/0`,
    { headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  // tslint:disable-next-line:max-line-length
  obtenerDataCredito(ce?, fecha_procesar?, fecha_saldos?, legal?, castigadas?, quitarCliente?, incluir?, limit?, offset?, orders?) {
    let params = new HttpParams();

    // console.log( 'SERV ' + incluir );

    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (ce) { // Busca registros por nombre|cobrador
      params = params.append('ce', ce);
    }
    if (fecha_procesar) { // Busca registros por fecha_procesar
      params = params.append('fecha_procesar', fecha_procesar);
    }
    if (fecha_saldos) { // Busca registros por fecha_saldos
      params = params.append('fecha_saldos', fecha_saldos);
    }
    if (legal) {
      params = params.append('legal', legal);
    }
    if (castigadas) {
      params = params.append('castigadas', castigadas);
    }
    if (quitarCliente) {
      params = params.append('quitar_cliente', quitarCliente);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    if (incluir) {
      params = params.append('incluir', incluir);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/lista-datacredito`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  removerClienteDataCredito(datos: any, tipo) {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`${this.helper.urlServer}/api/v1/remover-cliente-datacredito`, { clientes: datos, tipo }, { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  clientesExcluidosDatacredito() {
    return this.http.get(`${this.helper.urlServer}/api/v1/clientes-excluidos-datacredito`,
    { headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  recuperarClientesDatacredito(datos: any) {
    // tslint:disable-next-line:max-line-length
    return this.http.post(`${this.helper.urlServer}/api/v1/recuperar-cliente-datacredito`, { clientes: datos }, { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  // tslint:disable-next-line:max-line-length
  obtenerCuentasPorCobrar(ce?, fecha?, incluir?, limit?, offset?, rutas?, orders?) {
    let params = new HttpParams();

    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (ce) { // Busca registros por nombre|cobrador
      params = params.append('ce', ce);
    }
    if (fecha) { // Busca registros por fecha
      params = params.append('fecha', fecha);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    if (incluir) {
      params = params.append('incluir', incluir);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/cuentas-por-cobrar`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

 obtenerActividades(fechas?, empleados?, actividad?, limit?, offset?) {
    let params = new HttpParams();

    if (fechas) {

      params = params.append('fecha_desde', fechas.fecha_desde);
      params = params.append('fecha_hasta', fechas.fecha_hasta);
    }
    if (empleados) {
      params = params.append('empleados', empleados);
    }
    if (actividad) {
      params = params.append('actividad', actividad);
    }
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/actividades`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params});
  }

  tipoActividades() {
    return this.http.get(`${this.helper.urlServer}/api/v1/tipo-actividades`,
    { headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  atrasosPorRuta(empleado?, rutas?, incluir?, orders?) {
    let params = new HttpParams();
    if (incluir) {
      params = params.append('incluir', incluir);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (empleado) {
      params = params.append('empleado', empleado);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/atrasos-por-ruta`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  obtenerReporteGlobalDiario(fecha_desde?, fecha_hasta?, empresas?) {
    let params = new HttpParams();
    if (fecha_desde && fecha_hasta) {
      params = params.append('fecha_desde', fecha_desde);
      params = params.append('fecha_hasta', fecha_hasta);
    }
    if (empresas) {
      params = params.append('empresas', empresas);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/reporte-global-diario`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });

  }
  obtenerReporteSemanal(ciclo?, semana?, year?, ruta?, empresas?) {
    let params = new HttpParams();
    if (ciclo) {
      params = params.append('ciclo', ciclo);
    }
    if (semana) {
      params = params.append('semana', semana);
    }
    if (year) {
      params = params.append('year', year);
    }
    if (empresas) {
      params = params.append('empresas', empresas);
    }
    if (ruta) {
      params = params.append('ruta', ruta);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/reporte-semanal`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });

  }

  obtenerReporteSemanalEmpresas(ciclo?, semana?, year?, empresas?) {
    let params = new HttpParams();
    if (ciclo) {
      params = params.append('ciclo', ciclo);
    }
    if (semana) {
      params = params.append('semana', semana);
    }
    if (year) {
      params = params.append('year', year);
    }
    if (empresas) {
      params = params.append('empresas', empresas);
    }

    return this.http.get(`${this.helper.urlServer}/api/v1/reporte-semanal-empresas`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });

  }
  obtenerReporteConsolidadoCiudades(ciclo?, semana?, year?, ciudades?) {
    let params = new HttpParams();
    if (ciclo) {
      params = params.append('ciclo', ciclo);
    }
    if (semana) {
      params = params.append('semana', semana);
    }
    if (year) {
      params = params.append('year', year);
    }
    if (ciudades) {
      params = params.append('ciudades', ciudades);
    }

    return this.http.get(`${this.helper.urlServer}/api/v1/reporte-consolidado-ciudad`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });

  }
  companias() {
    return this.http.get(`${this.helper.urlServer}/api/v1/companias`,
    { headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  paginas() {
    return this.http.get(`${this.helper.urlServer}/api/v1/paginas`,
    { headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  permisos() {
    return this.http.get(`${this.helper.urlServer}/api/v1/permisos`,
    { headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  asignarCompaniaEmpleado(compania, ID_EMPLEADO) {
    return this.http.put(`${this.helper.urlServer}/api/v1/asignar-compania-empleado`,
    {compania, ID_EMPLEADO},
    { headers: this.helper.getHeader(localStorage.getItem('token')) });
 }

  asignarPaginaEmpleado(pagina, ID_EMPLEADO) {
    return this.http.put(`${this.helper.urlServer}/api/v1/asignar-pagina-empleado`,
    {pagina, ID_EMPLEADO},
    { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  asignarPermisoEmpleado(permiso, ID_EMPLEADO) {
    return this.http.put(`${this.helper.urlServer}/api/v1/asignar-permiso-empleado`,
    {permiso, ID_EMPLEADO},
    { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

 dineroEntregado(limit?, offset?, rutas?, empleado?, fecha_desde?, fecha_hasta?, orders?) {
    let params = new HttpParams();
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (limit && !isNaN(limit)) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    console.log(rutas)
    if (rutas) {
      console.log("ruta")
      params = params.append('rutas', rutas);
    }
    if (empleado) {
      params = params.append('empleado', empleado);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    return this.http.get( `${this.helper.urlServer}/api/v1/lista-dinero-entregado`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params }).map((res: any) => res);
  }

  saldaronNoRenovaron(limit?, offset?, rutas?, fecha_desde?, fecha_hasta?, orders?) {
    let params = new HttpParams();
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (limit && !isNaN(limit)) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    return this.http.get( `${this.helper.urlServer}/api/v1/lista-saldos-sin-renovos`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params }).map((res: any) => res);
  }

  obtenerCobrosPorZona(fecha_desde?, fecha_hasta?, rutas?, orders?) {
    let params = new HttpParams();
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    return this.http.get(`${this.helper.urlServer}/api/v1/cobros-por-zona`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  reporteGeneral(fecha_desde?, fecha_hasta?, ruta?) {
    let params = new HttpParams();
    if (fecha_desde) {
      params = params.append('fecha_desde', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_hasta', fecha_hasta);
    }
    if (ruta) {
      params = params.append('ruta', ruta);
    }

    return this.http.get(`${this.helper.urlServer}/api/v1/reporte-general`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });

  }

  compania() {
    return this.http.get(`${this.helper.urlServer}/api/v1/compania`,
    { headers: this.helper.getHeader(localStorage.getItem('token'))});
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/reportes.service.ts